import { AxiosQUANTUM, quantumOrgId, quantumUserId } from "../apiConfig";

export const orgId = quantumOrgId;
export const userId = quantumUserId;

export const organizationHierachyApiFactory = {
  $_getOrganizationStructure() {
    const url = `/org/${orgId()}/functions/structure`;
    return AxiosQUANTUM.get(url);
  },
  $_getAllFunctions() {
    const url = `/org/${orgId()}/functions`;
    return AxiosQUANTUM.get(url, {
      params: {
        include: "kpis",
      },
    });
  },
  $_getAllHierarchies() {
    const url = `/org/${orgId()}/hierarchies`;
    return AxiosQUANTUM.get(url);
  },
  $_getAllSupervisoryFunctions() {
    const url = "/hierarchy/get-all-superfunc";
    return AxiosQUANTUM.get(url);
  },
  $_createFunction(payload) {
    const url = "/org/functions";
    payload.orgId = orgId();
    payload.createdBy = userId()
    return AxiosQUANTUM.post(url, payload);
  },
  $_updateFunction(payload) {
    const url = "/org/functions";
    return AxiosQUANTUM.patch(url, payload);
  },
  $_deleteFunction(functionId) {
    const url = `/org/functions/${functionId}`;
    // functionId;
    // const url = `/org/functions`;
    return AxiosQUANTUM.delete(url);
  },
  // Job levels
  $_getJobLevels() {
    const url = `/org/${orgId()}/levels`;
    return AxiosQUANTUM.get(url);
  },
  $_createJobLevel(payload) {
    // const url = "/org/create";
    const url = `/org/levels`;
    payload.level.orgId = orgId();
    return AxiosQUANTUM.post(url, payload);
  },
  $_updateJobLevel(payload) {
    const url = "/org/levels";
    return AxiosQUANTUM.patch(url, payload);
  },
  $_getAllTags() {
    const url = `/org/${orgId()}/levels/tags`;
    return AxiosQUANTUM.get(url);
  },
  $_getDefaultJobLevels() {
    const url = "/org/levels/categories";
    return AxiosQUANTUM.get(url);
  },
  $_deleteJobLevel(id) {
    const url = "/org/levels";
    const ids = [id];
    return AxiosQUANTUM.delete(url, { data: ids });
  },

  // Designations
  $_getAllDesignations() {
    const url = `/org/${orgId()}/designations`;
    return AxiosQUANTUM.get(url);
  },
  $_createDesignation(payload) {
    const url = "/org/designations";
    payload.orgId = orgId();
    payload.createdBy = userId();
    return AxiosQUANTUM.post(url, payload);
  },
  $_deleteDesignation(id) {
    const url = `/org/delete-designation/${id}`;
    return AxiosQUANTUM.delete(url);
  },
  $_updateDesignation(payload) {
    const url = "org/designations";
    return AxiosQUANTUM.patch(url, payload);
  },

  // People
  $_getAllPeople(org = null) {
    let url = ""
    if (org)
      url = `/org/${org}/users`;
    else
      url = `/org/${orgId()}/users`;
    return AxiosQUANTUM.get(url);
  },
  $_createPerson(payload) {
    const url = "/users/people";
    payload.orgId = orgId();
    return AxiosQUANTUM.post(url, payload);
  },
  $_deletePeople(id) {
    const url = `/org/delete-people/${id}`;
    return AxiosQUANTUM.delete(url);
  },
  $_updatePerson(payload) {
    const url = `/user/${payload.id}/update`;
    return AxiosQUANTUM.patch(url, payload);
  },
  $_deactivatePerson(userId) {
    const url = `/org/deactivate/${userId}`;
    return AxiosQUANTUM.patch(url);
  },
  $_reactivatePerson(userId) {
    const url = `/org/activate/${userId}`;
    return AxiosQUANTUM.patch(url);
  },
};
